// noinspection JSUnresolvedVariable

import {
	Button,
	ButtonGroup,
	CardBody,
	CardHeader, Col,
	Form,
	FormGroup,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText, Row
} from "reactstrap";

import CryptoJS from 'crypto-js';
import { useMemo, useRef, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";
import "../../assets/scss/react/_buttons.scss";
import AuthData from "../../lib/Core/AuthData";
import Authenticate from "../../lib/Core/Authenticate";
import Notify from "../../lib/Utils/Alert";
import { IoArrowBackCircle } from "react-icons/io5";
//import CryptoJS from 'crypto-js';


const LoginFragment = (props) =>
{
	const history = useHistory();
	const notifyRef = props.notifyArea;
	const form = useRef();
	const [formState, setFormState] = useState("Login");
	const [session, setSession] = useState(null);
	const [accessToken, setAccessToken] = useState(null);
	const [username, setUsername] = useState(null);
	const [password, setPassword] = useState(null);
	const [formTitle, setFormTitle] = useState("Please provide your credentials");
	const [showbackButton,setShowBackButton] = useState(false);
	const [buttonTitle, setButtonTitle] = useState("Sign In");
	const [mfaRadioSelected, setMFARadioSelected] = useState(null);
	const [mfaType,setMfaType] = useState("NONE");
	const [passwordType, setPasswordType] = useState("password");
	const [confPasswordType,setConfPasswordType] = useState("password")
	const [titleRemove,setTitleRemove] = useState(false);
	const [isLoading,setIsLoading] = useState(false);
	const [isLoading1,setIsLoading1] = useState(false);
	const [isLoading2,setIsLoading2] = useState(false);
	const pass_key=process.env.REACT_APP_PASS_KEY
	const iv = CryptoJS.lib.WordArray.random(16);

	const loadingFunction = () =>{
		setTimeout(() => {
			setIsLoading(false);
		  }, 1500);
	}
	const loadingFunction1 = () =>{
		setTimeout(() => {
			setIsLoading1(false);
		  }, 1500);
	}
	const loadingFunction2 = () =>{
		setTimeout(() => {
			setIsLoading2(false);
		  }, 1500);
	}
	const togglePassword =()=>{
		if(passwordType==="password"){
		 setPasswordType("text")
		 return;
		}
		setPasswordType("password")
	  }

	  const confirmtogglePassword = () =>{
        if(confPasswordType==="password"){
			setConfPasswordType("text")
			return;
	  }
	  setConfPasswordType("password")
	}

	  const togglePasswordButton = {
		right: '5px',
		top: '49%',
		transform: 'translateY(-50%)',
		border: '0px',
		backgroundColor: 'transparent',
		zIndex: 3,
	  };

	const destination = props.destination;
	let processing = false;

	const authCtl = useMemo(() => new Authenticate(props.securityGroup),[props.securityGroup]);

	function NotifyError(msg)
	{
		Notify(notifyRef, "danger", msg);
		processing = false;
	}

	function NotifyWarning(msg)
	{
		Notify(notifyRef, "warning", msg);
	}

	function NotifyInfo(msg)
	{
		Notify(notifyRef, "info", msg);
	}

	function NotifySuccess(msg)
	{
		Notify(notifyRef, "success", msg);
	}

	function otpModeConfirmation(e) {
	setIsLoading2(true);
		e.preventDefault();
		const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
			iv: iv,
			padding: CryptoJS.pad.Pkcs7,
			mode: CryptoJS.mode.CBC,
		  });
		  const ivString = CryptoJS.enc.Base64.stringify(iv);
		  const encryptedString = encrypted.toString();
		  const finalEncryptedPassword = `${ivString}:${encryptedString}`;
		  if(mfaType === "AUTHENTICATOR"){
			authCtl.login(username, finalEncryptedPassword.trim(),mfaType,).then((data) =>
				{
				if (data.challengeName === "NEW_PASSWORD_REQUIRED")
					{
						NotifyWarning("You must provide a new password for your account");
						loadingFunction()
						setFormTitle("Please provide a new password");
						setButtonTitle("Save New Password");
						setFormState("ForcePasswordChange");
						setSession(data.session);
						setUsername(data.username);
					}
					else if (data.challengeName === "NO_MFA")
					{
						setFormTitle("Select your mode");
						setFormState("AuthModeConfirmation");
						setTitleRemove(true)
						loadingFunction()
					}else if(data.challengeName === "SOFTWARE_TOKEN_MFA" ||  data?.qrCode?.length > 0 ){
						history.replace('/auth/admin-qr');
						localStorage.setItem('QRdataAdmin',JSON.stringify(data))
					}
					else if (data.accessToken)
					{
						setFormTitle("Please enter the confirmation code");
						setButtonTitle("Confirm Account");
						setUsername(form.current.username.value);
						setAccessToken(data.accessToken);
						authCtl.requestPhoneVerification(data.accessToken).then(() =>
						{
							NotifyInfo("A confirmation code was sent to your phone via SMS");
							loadingFunction()
							setFormState("PhoneVerificationCode");
						}).catch(NotifyError);
						loadingFunction()
					}
					else if (data.forcePasswordChange)
					{
						NotifyWarning("Your account is disabled, you must change your password.");
						loadingFunction()
						setFormState("ForgotPassword");
						setFormTitle("Input your user name");
						setShowBackButton(true)
						setButtonTitle("Recover Password");
						setSession(null);
						setUsername(null);
						setPassword(null);
					}
					else if (data.error === "Invalid username or password") {
						NotifyWarning("Invalid username or password");
						loadingFunction()
					}
					processing = false;
				})
			} else {
			authCtl.requestMFACode(username, finalEncryptedPassword.trim(), mfaRadioSelected === 1 ? 'sms' : mfaRadioSelected === 2 ? 'mail' : "totp").then(data =>
				{
					if (data.status === false) {
						if (data.errorCode === 'NUMBER_NOT_VERIFIED'){
							if (window.confirm("Do you want to verify your PhoneNo?")) {
								authCtl.getPhoneNoVerificationCodeFromCognito(username).then(data =>{
									if (data.status === 'true') {
										setFormTitle("Please Enter OTP to verify");
										setButtonTitle("Verify");
										setFormState("VerifyPhoneFromCognito");
										loadingFunction2()
									} else {
										NotifyError(data.errorMessage)
										loadingFunction2()
									}
								})
							} else {
								NotifyInfo("PhoneNo not verified, Please us email for receiving OTP")
								loadingFunction2()
							}
							
						} else 
							NotifyError(data.errorMessage)
							loadingFunction2()
					}
					if (data.Success === true) {
						if (mfaRadioSelected === 1) {
							NotifyInfo("A verification code was sent to your phone via SMS");
							loadingFunction2()
						} 
						if (mfaRadioSelected === 2) {
							NotifyInfo("A verification code was sent to your email address.");
							loadingFunction2()
						}
						setFormTitle("Please enter the code you received");
						setShowBackButton(true)
						setButtonTitle("Verify Code");
						setFormState("RequestMFACode");
						loadingFunction2()
					}
				}).catch(NotifyError);
		  }
	

	}

	if (!!props.forgotPassCode)
	{
		setFormTitle("Input the recovery code you received");
		setButtonTitle("Recover Password");
		setSession(null);
		setUsername(null);
		setPassword(null);
		setFormState("ConfirmForgotPassword");
	}

	function authenticate(e)
	{
		setIsLoading(true)
		e.preventDefault();
		if (!processing)
		{
			processing = true;
			switch (formState)
			{
				case "Login":
					if (!form.current.username.value || !form.current.password.value)
					{
						NotifyWarning("You must provide a username and a password");
						loadingFunction()
						processing = false;
					}
					else if (!/^[\w-]+(?:\.[\w-]+)*(\+[^\@]+)?@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/.test(form.current.username.value)) {
						NotifyWarning("Please enter a valid email address");
						loadingFunction()
						processing = false;
					}
					else 
					{
						const encrypted = CryptoJS.AES.encrypt(form.current.password.value, CryptoJS.enc.Utf8.parse(pass_key), {
							iv: iv,
							padding: CryptoJS.pad.Pkcs7,
							mode: CryptoJS.mode.CBC,
						  });
						  const ivString = CryptoJS.enc.Base64.stringify(iv);
						  const encryptedString = encrypted.toString();
						  const finalEncryptedPassword = `${ivString}:${encryptedString}`;
						authCtl.login(form.current.username.value, finalEncryptedPassword.trim(),mfaType, !!form.current.new_password ? form.current.new_password.value : null).then((data) =>
						{
							setPassword(form.current.password.value);
							setUsername(form.current.username.value);

							
							if (data.challengeName === "NEW_PASSWORD_REQUIRED")
							{
								NotifyWarning("You must provide a new password for your account");
								loadingFunction()
								setFormTitle("Please provide a new password");
								setButtonTitle("Save New Password");
								setFormState("ForcePasswordChange");
								setSession(data.session);
								setUsername(data.username);
							}
							else if (data.challengeName === "NO_MFA" || data?.challengeName === "SOFTWARE_TOKEN_MFA")
							{
								// localStorage.setItem('QRdataAdmin',JSON.stringify(data))
								localStorage.setItem("session",JSON.stringify(data?.session))
								setFormTitle("Select your mode");
								setShowBackButton(true)
								setFormState("AuthModeConfirmation");
								setTitleRemove(true)
								loadingFunction()
							}
							else if (data.accessToken)
							{
								setFormTitle("Please enter the confirmation code");
								setButtonTitle("Confirm Account");
								setUsername(form.current.username.value);
								setAccessToken(data.accessToken);
								authCtl.requestPhoneVerification(data.accessToken).then(() =>
								{
									NotifyInfo("A confirmation code was sent to your phone via SMS");
									loadingFunction()
									setFormState("PhoneVerificationCode");
								}).catch(NotifyError);
								loadingFunction()
							}
							else if (data.forcePasswordChange)
							{
								NotifyWarning("Your account is disabled, you must change your password.");
								loadingFunction()
								setFormState("ForgotPassword");
								setFormTitle("Input your user name");
								setShowBackButton(true)
								setButtonTitle("Recover Password");
								setSession(null);
								setUsername(null);
								setPassword(null);
							}
							else if (data.error === "Invalid username or password") {
								NotifyWarning("Invalid username or password");
								loadingFunction()
							}
							processing = false;
						})
					}
					break;

				case "ForcePasswordChange":
					const hasUpperCase = /[A-Z]/; 
					const hasLowerCase = /[a-z]/; 
					const hasNumber = /[0-9]/;   
					const hasSpecialChar = /[!@#?$%*&]/;
					const minLength = /^.{8,}$/; 
					if (!minLength.test(form.current.new_password.value) || !hasUpperCase.test(form.current.new_password.value) || !hasLowerCase.test(form.current.new_password.value) || !hasNumber.test(form.current.new_password.value) || !hasSpecialChar.test(form.current.new_password.value)) {
						NotifyError("Password does not meet complexity requirements. Please ensure it includes at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character like (!, @, #, ?,$,%,&,*).");
						loadingFunction();
						processing = false;
						return;
					}
					if (form.current.new_password.value !== form.current.conf_new_password.value)
					{
						NotifyError("The passwords don't match, please verify.");
						loadingFunction()
						processing = false;
					}
					else
					{
					authCtl.forcePasswordChange(session, username, form.current.new_password.value).then(data =>
						{
							form.current.new_password.value = "";
							form.current.conf_new_password.value = "";
							NotifySuccess("Password updated successfully, please login with your new password.");
							loadingFunction()
							setFormTitle("Please provide your credentials");
							setShowBackButton(false)
							setButtonTitle("Sign In");
							setFormState("Login");
							processing = false;
						}).catch(NotifyError);
						loadingFunction()
					}
					break;

				case "RequestMFACode":
					const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
						iv: iv,
						padding: CryptoJS.pad.Pkcs7,
						mode: CryptoJS.mode.CBC,
					  });
					  const ivString = CryptoJS.enc.Base64.stringify(iv);
					  const encryptedString = encrypted.toString();
					  const finalEncryptedPassword = `${ivString}:${encryptedString}`;
					 if(form.current.mfa_code.value.length < 6 || form.current.mfa_code.value.length > 6){
						NotifyWarning("Enter a valid OTP");
						loadingFunction()
						processing = false;
						return;
					  }
					authCtl.validateMFACode(username, finalEncryptedPassword.trim(), form.current.mfa_code.value).then(data =>
					{

						setAccessToken(data.accessToken)
						const tokenValidator = new AuthData(props.securityGroup, true);
						if(data.error === "Error: Invalid verification code. Please check the code you entered and try again.") {
							NotifyWarning("Error: Invalid verification code. Please check the code you entered and try again.");
							loadingFunction()
						}
						else if(data.error === "Please Enter correct OTP"){
							NotifyError("Please Enter correct OTP")
							loadingFunction()
						}else if(data.error === "OTP expired, please try again with new OTP"){
                            NotifyError("OTP expired, please try again with new OTP")
							loadingFunction()
						}else if (!tokenValidator.setToken(data.accessToken))
						{
						
							// NotifyError("Please Enter correct OTP")
							setFormTitle("Please provide your credentials");
							setButtonTitle("Sign In");
							setFormState("Login");
							setShowBackButton(false)
							loadingFunction()
						}
						else
						{
							sessionStorage.setItem("accessToken", JSON.stringify(tokenValidator));
							history.push(destination);
							loadingFunction()
						}
						processing = false;
					}).catch((error)=>{
						NotifyError(error)
						loadingFunction()
					});
					break;

				case "VerifyPhoneFromCognito":
					authCtl.verifyPhoneNoVerificationResult(form.current.phone_verification_code.value, username).then(data => {
						if (data.status === 'true') {
							NotifyInfo(data.Message)
							loadingFunction()
							setFormState("AuthModeConfirmation")
						} else {
							NotifyError(data.errorMessage)
							loadingFunction()
						}
					})
					break
				case "PhoneVerificationCode":
					authCtl.verifyPhone(accessToken, username, form.current.phone_code.value).then(data =>
					{
						NotifySuccess("Phone number verified, please re-login on your account.");
						loadingFunction()
						setFormTitle("Please provide your credentials");
						setButtonTitle("Sign In");
						setShowBackButton(false)
						setFormState("Login");
						processing = false;
					}).catch(NotifyError);
					loadingFunction()
					break;

				case "ForgotPassword":
					
                  authCtl.forgotPassword(form.current.username.value).then(() =>
					{
						
						NotifyInfo("An email was sent to your inbox with further instructions to recover your password");
						loadingFunction()
						setFormTitle("Input the recovery code you received");
						setButtonTitle("Recover Password");
						setSession(null);
						setUsername(null);
						setPassword(null);
						setFormState("ConfirmForgotPassword");
						processing = false;
					}).catch(NotifyError);
					loadingFunction()
					break;

				case "ConfirmForgotPassword":
					const lowerCaseRegex = /[a-z]/;
					const upperCaseRegex = /[A-Z]/;
					const numberRegex = /[0-9]/;
					const specialCharacterRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

					if (form.current.forgot_code.value === "")
					{
						NotifyError("Please Provide Recovery Code");
						loadingFunction()
						
					}else if(form.current.username.value === ""){
                     NotifyError("Email Field Can Not Be Empty");
					 loadingFunction()

					}else if(form.current.new_password.value === ""){
						NotifyError("New Password Field Can Not Be Empty");
						loadingFunction()
					}else if(form.current.new_password.value !== form.current.conf_new_password.value){
						
						NotifyError("The passwords don't match, please verify.");
						loadingFunction()
						processing = false;
					}
					else if(form.current.new_password.value.length  <8){
						NotifyError("Password can not be less than 8")
						loadingFunction()

					}else if (!lowerCaseRegex.test(form.current.new_password.value) 
					|| !upperCaseRegex.test(form.current.new_password.value) 
					|| !numberRegex.test(form.current.new_password.value) 
					|| !specialCharacterRegex.test(form.current.new_password.value)) {
						NotifyError("Password must include a mixture of both lower case and upper case letters, a mixture of letters and numbers, and at least one special character (!, @, #, ?,$,%,&,*).");
						loadingFunction()
					}else
					{
						authCtl.confirmForgotPassword(form.current.forgot_code.value, form.current.username.value, form.current.new_password.value).then(() =>
						{
							// setTimeout(() => {
								setIsLoading(false)
							// }, 500);
							form.current.new_password.value = "";
							form.current.conf_new_password.value = "";
							NotifySuccess("Password updated successfully, please login with your new password.");
							setFormTitle("Please provide your credentials");
							setShowBackButton(false)
							setButtonTitle("Sign In");
							setFormState("Login");
							processing = false;
						}).catch(NotifyError);
						loadingFunction()
					}
					break;
				default:
			}
		}
	}

	function resendMFA()
	{
		setIsLoading1(true);
		if (!processing)
		{
			processing = true;
			
			if (formState === "RequestMFACode")
			{
				const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
					iv: iv,
					padding: CryptoJS.pad.Pkcs7,
					mode: CryptoJS.mode.CBC,
				  });
				  const ivString = CryptoJS.enc.Base64.stringify(iv);
				  const encryptedString = encrypted.toString();
				  const finalEncryptedPassword = `${ivString}:${encryptedString}`;
				authCtl.requestMFACode(username, finalEncryptedPassword.trim(), mfaRadioSelected === 1 ? 'sms' :mfaRadioSelected === 2 ?  'mail' : "totp").then((data) =>
				{
					if (data.Success === true) {
						if (mfaRadioSelected === 1) {
							NotifyInfo("A verification code was sent to your phone via SMS");
							loadingFunction1()
						} 
						if (mfaRadioSelected === 2) {
							NotifyInfo("A verification code was sent to your email address.");
							loadingFunction1()
						}
					} else {
						NotifyError(data.errorMessage)
						loadingFunction1()
					}
					processing = false;
				}).catch(NotifyError);
			}
		}
	}

	function forgotPassword(e)
	{
		e.preventDefault();
		setFormState("ForgotPassword");
		setFormTitle("Input your user name");
		setShowBackButton(true)
		setButtonTitle("Recover Password");
		setTitleRemove(true)
		setSession(null);
		setUsername(null);
		setPassword(null);
	}

	const handleBacktologin = () =>{
		setTitleRemove(false)
		setFormTitle("Please provide your credentials");
		setShowBackButton(false)
		setButtonTitle("Sign In");
		setFormState("Login");
	}

	return (<>
		<CardHeader className="text-center  py-3" style={{backgroundColor: !!props.titleBgColor ? props.titleBgColor : "#2665F2", color: !!props.titleColor ? props.titleColor : "#FFFFFF", fontWeight: "bold"}}>
			<div className="d-flex flex-row">
			{
				showbackButton ?
				<div className="d-flex align-items-center admin_back_button" style={{cursor:"pointer"}} onClick={handleBacktologin}>
				<IoArrowBackCircle className="fs-5 me-1" />
				<p className=" mb-0" >
				Back
			</p>
			</div>
			:""
			}
			<p className="d-flex align-items-center mb-0 ms-5">{formTitle}</p>
			</div>
		</CardHeader>
		<CardBody className="px-lg-4 py-lg-4">
			<Form role="form" innerRef={form} onSubmit={() => false}>
				{formState === "ForgotPassword" ? <>
					<FormGroup className="mb-3">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-envelope"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Email" type="email" name="username" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
				</> : <></>}
				{formState === "ConfirmForgotPassword" ? <>
					<FormGroup className="mb-3">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-barcode"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Recovery code" type="text" maxLength="6" name="forgot_code" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
					<FormGroup className="mb-3">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-envelope"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Email" type="email" name="username"/>
						</InputGroup>
					</FormGroup>
					<FormGroup>
					<div className="position-relative" >
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-key"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="New Password" type={passwordType} name="new_password"/>
						</InputGroup>
						<button
						type="button"
						onClick={togglePassword}
						className=" position-absolute"
						style={togglePasswordButton}
						>
                          {passwordType === "password" ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}
						</button>
						</div>
					</FormGroup>
					<FormGroup>
					<div className="position-relative" >
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-key"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Confirm Password" type={confPasswordType} name="conf_new_password"/>
						</InputGroup>
						<button
						type="button"
						onClick={confirmtogglePassword}
						className=" position-absolute"
						style={togglePasswordButton}
						>
                          {confPasswordType === "password" ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}
						</button>
						</div>
					</FormGroup>
				</> : <></>}
				{formState === "Login" ? <>
					<FormGroup className="mb-3">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="py-0 px-2">
									<i className="fas fa-envelope"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Email" type="email" name="username" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
					<FormGroup>
						<div className="position-relative" >
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="py-0 px-2">
									<i className="fas fa-key"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Password" type={passwordType} name="password"/>
						</InputGroup>
						<button
						type="button"
						onClick={togglePassword}
						className=" position-absolute"
						style={togglePasswordButton}
						>
                          {passwordType === "password" ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}
						</button>
						</div>
					</FormGroup>
				</> : <></>}
				{formState === "ForcePasswordChange" ? <>
					<FormGroup>
					 <div className="position-relative">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-key"/>
									&nbsp;&nbsp;
								</InputGroupText>
								
							</InputGroupAddon>
							<Input placeholder="New Password" type={passwordType} name="new_password" autoFocus={true}/>
						</InputGroup>
						<button
						type="button"
						onClick={togglePassword }
						className="position-absolute"
						style={togglePasswordButton}
						>
                         {passwordType === "password" ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}
						</button>
						</div>
					</FormGroup>
					<FormGroup>
                      <div className="position-relative">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-key"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Confirm Password" type={confPasswordType} name="conf_new_password"/>
						</InputGroup>
						<button
						type="button"
						onClick={confirmtogglePassword}
						className="position-absolute"
						style={togglePasswordButton}
						>
                         {confPasswordType === "password" ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}
						</button>
						</div>
					</FormGroup>
				</> : <></>}
				{formState === "RequestMFACode" ? <>
					<FormGroup>
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="py-0 px-2">
									<i className="fas fa-user-secret text-danger"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input className="custom-input" placeholder="MFA Code" type="number" name="mfa_code" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
				</> : <></>}
				{formState === "PhoneVerificationCode" ? <>
					<FormGroup>
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-user-secret text-danger"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Phone verification code" type="number" name="phone_code" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
				</> : <></>}
				{formState === "VerifyPhoneFromCognito" ? <>
					<FormGroup>
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fas fa-user-secret text-danger"/>
									&nbsp;&nbsp;
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Enter OTP" type="number" name="phone_verification_code" autoFocus={true}/>
						</InputGroup>
					</FormGroup>
				</> : <></>}
				{formState === "AuthModeConfirmation" ? <>
					<ButtonGroup className="d-flex justify-content-between custom-button-group">
						<Button className={`m-3 custom-button ${mfaRadioSelected === 1 ? 'active-button' : ''}`}   onClick={() => {setMFARadioSelected(1);setMfaType("NONE")}} active={mfaRadioSelected === 1}> SMS MFA </Button>
						<Button className={`m-3 custom-button ${mfaRadioSelected === 2 ? 'active-button' : ''}`}   onClick={() => {setMFARadioSelected(2);setMfaType("NONE")}} active={mfaRadioSelected === 2}> Email MFA </Button>
						{/* <Button className={`m-3 custom-button ${mfaRadioSelected === 3 ? 'active-button' : ''}`}   onClick={() => {setMFARadioSelected(3);setMfaType("AUTHENTICATOR")}} active={mfaRadioSelected === 3}> TOTP MFA </Button> */}
					</ButtonGroup>
				</> : <></>}
				<div className="text-center">
				{formState === "RequestMFACode" ? (
					<>
						<Button type="button" className="my-4 btn btn-primaryTwo"  onClick={resendMFA} disabled={isLoading1}>
						{!isLoading1 && "Resend Verification Code"} {isLoading1 && <Spinner
							as="span"
							animation="border"
							size="sm"
							role="status"
							aria-hidden="true"
							style={{
							margin: "0px 8px"
							}}
						/>}
						</Button>
						<Button type="submit" className="my-4 btn btn-primaryTwo"  onClick={authenticate}disabled={isLoading}>
						{!isLoading && buttonTitle}{isLoading && <Spinner
							as="span"
							animation="border"
							size="sm"
							role="status"
							aria-hidden="true"
							style={{
							margin: "0px 8px"
							}}
						/>}
						</Button>
					</>
					) : formState === "AuthModeConfirmation" ? (
					<>
						<Button type="button" className="my-4 btn btn-primaryTwo"  onClick={otpModeConfirmation}disabled={isLoading2}>
						{!isLoading2 && "Next"}{isLoading2 && <Spinner
							as="span"
							animation="border"
							size="sm"
							role="status"
							aria-hidden="true"
							style={{
							margin: "0px 8px"
							}}
						/>}
						</Button>
					</>
					) : (
					<>
						<Button type="submit" className="my-4 btn btn-primaryTwo"  onClick={authenticate} disabled={isLoading}>
						{!isLoading && buttonTitle}{isLoading && <Spinner
							as="span"
							animation="border"
							size="sm"
							role="status"
							aria-hidden="true"
							style={{
							margin: "0px 8px"
							}}
						/>}
						</Button>
					</>
					)}
				</div>
			</Form>
			<Row className="mt-3">
				{titleRemove === true ? "" 
				:
				<Col xs="12">
					<a className="text-dark" href="javascript(0);" onClick={forgotPassword}>
						<small>Forgot password?</small>
					</a>
				</Col>
               }
			</Row>
		</CardBody>
	</>);
};

export default LoginFragment;